import React from "react";
import Login from "../screens/Account/Login";
import Layout from "../layouts/GeneralLayout";
const MobileLoginPage = () => (
  <Layout>
    <Login />
  </Layout>
);
export default MobileLoginPage;
